import { createFileRoute } from '@tanstack/react-router'
import { useForm } from '@tanstack/react-form'
import { useTranslation } from 'react-i18next'
import { usePageSEO } from '@/hooks/usePageSEO'

export const Route = createFileRoute('/contactUs')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ContactUs />
}

function ContactUs() {
  const { t } = useTranslation()
  usePageSEO({
    title: 'Contact JeridSchool - Demo pour votre ecole en Tunisie',
    description:
      'Contactez JeridSchool pour decouvrir notre plateforme de gestion scolaire adaptee aux etablissements en Tunisie.',
    keywords:
      'contact JeridSchool, demo logiciel scolaire, gestion ecole Tunisie, plateforme scolaire Tunisie',
    path: '/contactUs',
  })

  const form = useForm({
    defaultValues: {
      email: '',
      subject: '',
      message: '',
    },
    onSubmit: async () => {
      try {
    // console.logForm submitted successfully:', value)
        // Handle form submission, e.g., send to an API
        alert(t('routes.contactUs.alerts.success'))
      } catch (error) {
        // console.error('Submission error:', error)
        alert(t('routes.contactUs.alerts.error'))
      }
    },
  })

  return (
    <div className="flex h-screen mt-[1px]">
      {/* Left side form */}
      <div className="flex-1 flex items-center justify-center">
        <div className="w-full max-w-md space-y-8 px-4">
          <div className="text-center">
            <h2 className="text-4xl font-extrabold text-gray-900 dark:text-white">
              {t('routes.contactUs.title')}
            </h2>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
              {t('routes.contactUs.description')}
            </p>
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault()
              e.stopPropagation()
              form.handleSubmit()
            }}
            className="space-y-6"
          >
            <div>
              <form.Field
                name="email"
                children={(field) => (
                  <input
                    name={field.name}
                    value={field.state.value}
                    onBlur={field.handleBlur}
                    onChange={(e) => field.handleChange(e.target.value)}
                    type="email"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    placeholder={t(
                      'routes.contactUs.form.fields.email.placeholder'
                    )}
                  />
                )}
              />
            </div>
            <div>
              <form.Field
                name="subject"
                children={(field) => (
                  <input
                    name={field.name}
                    value={field.state.value}
                    onBlur={field.handleBlur}
                    onChange={(e) => field.handleChange(e.target.value)}
                    type="text"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    placeholder={t(
                      'routes.contactUs.form.fields.subject.placeholder'
                    )}
                  />
                )}
              />
            </div>
            <div>
              <form.Field
                name="message"
                children={(field) => (
                  <textarea
                    name={field.name}
                    value={field.state.value}
                    onBlur={field.handleBlur}
                    onChange={(e) => field.handleChange(e.target.value)}
                    rows={6}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    placeholder={t(
                      'routes.contactUs.form.fields.message.placeholder'
                    )}
                  />
                )}
              />
            </div>
            <button
              type="submit"
              disabled={form.state.isSubmitting}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-3xl shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {form.state.isSubmitting
                ? t('routes.contactUs.form.button.sending')
                : t('routes.contactUs.form.button.submit')}
            </button>
          </form>

          {/* Contact Information */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <h3 className="text-lg font-medium text-gray-900 mb-4">
              {t('routes.contactUs.contactInfo.title')}
            </h3>
            <div className="space-y-2 text-sm text-gray-600">
              <p>{t('routes.contactUs.contactInfo.address')}</p>
              <p>Email: {t('routes.contactUs.contactInfo.email')}</p>
              <p>Website: {t('routes.contactUs.contactInfo.website')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
